module.exports = __webpack_public_path__ + "static/media/19.2eb9a0eb.jpg";